import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NavBarAction, NavbarItem } from '@timechef/core/models/app';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavbarComponent {
  @Input() items: NavbarItem[] = [];

  @Output() triggerAction = new EventEmitter<NavBarAction>();

  trackByKey = (_idx: any, item: NavbarItem) => item.key;
}
